import * as React  from 'react';
import { ActorAvatar, ActorName } from './actor';
import { combinedViewTime } from './dateKey';
import ChangeRow from './changeRow';

/**
 * A Workkard-level action: a sponsor handover, or a close/reopen.
 *
 * A sponsor change carries both sides as user ids, so it renders the two-avatar
 * transfer block. A status change carries only values, so it falls back to the
 * same from/to row the logs use.
 */
export default function WorkkardActionHistoryTemplate({ data }) {
    const change = data.change || {};
    const isTransfer = !!(change.from_user_id || change.to_user_id);

    return(
            <div className="combinedListing detailListing">
                <div className="combinedCreatedDate detailCreatedDate">
                    <ActorAvatar userId={data.actor_id} />
                </div>
                <div className="combinedRightBlock detailRightBlock resolutionChanged">
                    <div className="combinedDescription detailDescription">
                        <div className="alignMiddle mb mb__8 flexWrap">
                            <ActorName userId={data.actor_id} inner="header" />
                            <span className="dateTime mr">
                                <label className="mrNone">{combinedViewTime(data.occurred_at)}</label>
                            </span>
                            {isTransfer ? "changed workkard owner" : "changed workkard status"}
                        </div>
                    </div>

                    {isTransfer ? (
                        <div className="userAssignee userGroup rowFlex alignMiddle col-3">
                            <ul className="flexGrow">
                                <li>
                                    <div className="userPic rowFlex">
                                        <ActorAvatar userId={change.from_user_id} />
                                        <div className="colFlex ml">
                                            <label>From</label>
                                            <ActorName userId={change.from_user_id} />
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div className="userPic rowFlex">
                                        <ActorAvatar userId={change.to_user_id} />
                                        <div className="colFlex ml">
                                            <label>To</label>
                                            <ActorName userId={change.to_user_id} />
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    ) : (
                        <div className="update_information">
                            <ul className="logs_listing">
                                <ChangeRow change={data.change} />
                            </ul>
                        </div>
                    )}
                </div>

            </div>
        )
}
